import { Guest, GuestStats } from '../types';

export function calculateGuestStats(guests: Guest[]): GuestStats {
  return guests.reduce<GuestStats>(
    (stats, guest) => ({
      guests: stats.guests + 1,
      weisswurst: stats.weisswurst + guest.weisswurst,
      beerLitres: stats.beerLitres + (guest.bier ? 3 : 0),
      aperol: stats.aperol + (guest.aperol ? 1 : 0),
      alkoholfrei: stats.alkoholfrei + (guest.alkoholfrei ? 1 : 0),
      moscowMule: stats.moscowMule + (guest.moscowMule ? 1 : 0),
    }),
    { guests: 0, weisswurst: 0, beerLitres: 0, aperol: 0, alkoholfrei: 0, moscowMule: 0 },
  );
}
